export enum PromoBannerTagThemeEnum {
  TAGTHEME_LIGHT = 'TAGTHEME_LIGHT',
  TAGTHEME_DARK = 'TAGTHEME_DARK',
  TAGTHEME_PROMO1 = 'TAGTHEME_PROMO1',
  TAGTHEME_PROMO2 = 'TAGTHEME_PROMO2'
}
